import { TFaviconConfig } from './types';

type FaviconModule = {
  favicons: TFaviconConfig[];
};

type BrandImport = () => Promise<FaviconModule>;
type ThemeSupport = { default: BrandImport; [theme: string]: BrandImport };

const brandImports: Record<string, ThemeSupport> = {
  V: { default: () => import('./vw') },
  N: { default: () => import('./vw') },
  A: { default: () => import('./audi') },
  S: { default: () => import('./cupra') },
  E: { default: () => import('./bentley') },
  L: {
    default: () => import('./lamborghini/light'),
    dark: () => import('./lamborghini/dark'),
  },
};

const getImportFunction = (brand: string, theme: string): BrandImport => {
  const brandConfig = brandImports[brand] || brandImports['A'];
  return brandConfig[theme] || brandConfig.default;
};

export const getFavicons = async (brand: string, theme: string = 'light'): Promise<FaviconModule> => {
  const importFn = getImportFunction(brand, theme);
  return await importFn();
};
